export const getApiUrl = (tier: string): string => {
  const path = '/brandfree-prepaid/api';
  if (tier === 'local') {
    return `https://localhost.telia.ee:3333${path}`;
  }
  const subdomain = { dev: '-dev', test: '-test', live: '' }[tier] || '';

  return `https://topup${subdomain}.telia.ee${path}`;
};
